<template>
  <div class="order">
    <!-- 表单区域 -->
    <div class="serch-wrap">
      <el-form
        label-position="left"
        :inline="true"
        :model="orderForm"
        class="demo-form-inline"
      >
        <el-form-item label="主订单号">
          <el-input
            @keyup.enter.native="searchOrderList"
            v-model="orderForm.main_number"
            placeholder="主订单号"
          />
        </el-form-item>
        <el-form-item label="子订单号">
          <el-input
            @keyup.enter.native="searchOrderList"
            v-model="orderForm.order_number"
            placeholder="子订单号"
          />
        </el-form-item>
        <el-form-item label="编号" label-width="40px">
          <el-input v-model="orderForm.serialNumber" />
        </el-form-item>
        <!-- 主单状态 -->
        <el-form-item label="主单状态">
          <el-select
            v-model="orderForm.mainOrderStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in mainOrderOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 同步状态 -->
        <el-form-item label="同步状态" v-if="syncStatusFlag">
          <el-select
            v-model="orderForm.syncStatus"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in syncOptions"
              :key="item.value"
              :label="item.label"
              :value="item.value"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 物流状态（直发|工厂）2022-10-14新增 -->
        <el-form-item
          label="物流状态"
          v-if="statusActive === 4 && isZhifaOrFactory"
        >
          <el-select
            v-model="orderForm.box_status"
            clearable
            placeholder="请选择"
          >
            <el-option
              v-for="item in Object.keys(logStatusOptions)"
              :key="item"
              :label="logStatusOptions[item]"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="推送日期">
          <el-col :span="11">
            <el-date-picker
              type="datetime"
              placeholder="开始日期"
              v-model="orderForm.start_created_at"
              style="width: 100%"
            />
          </el-col>
          <el-col class="line" :span="2">-</el-col>
          <el-col :span="11">
            <el-date-picker
              type="datetime"
              placeholder="结束日期"
              v-model="orderForm.end_created_at"
              style="width: 100%"
            />
          </el-col>
        </el-form-item>
        <el-form-item
          label="物流联系电话"
          label-width="85px"
          v-show="
            (statusActive === 4 && isZhifaOrFactory && canInputTs) ||
              (statusActive === 3 && isZhifaOrFactory && canInputTs)
          "
        >
          <el-input v-model="orderForm.courier_mobile" />
        </el-form-item>
        <el-form-item label="报备状态" label-width="60px">
          <el-select
            v-model="orderForm.shipping_status"
            placeholder="选择报备状态"
            clearable
            multiple
          >
            <el-option
              v-for="item in Object.keys(shipStatusOptions)"
              :key="item"
              :label="shipStatusOptions[item]"
              :value="item"
            />
          </el-select>
        </el-form-item>
        <el-form-item label="关联单号" v-if="statusActive === 6">
          <el-input v-model="orderForm.as_number" placeholder="关联单号" />
        </el-form-item>
        <div class="drop-down-wrap">
          <transition name="el-fade-in-linear">
            <el-button
              v-if="!dropStatus"
              type="text"
              icon="iconfont icon-xiangxiashuangjiantou"
              style="
                background: #fff;
                border: none;
                color: #666;
                font-size: 24px;
                padding: 0;
              "
              @click="dropHandler"
            ></el-button>
            <el-button
              v-if="dropStatus"
              type="text"
              icon="iconfont icon-xiangshangshuangjiantou"
              style="
                background: #fff;
                border: none;
                color: #666;
                font-size: 24px;
                padding: 0;
              "
              @click="dropHandler"
            ></el-button>
          </transition>
        </div>
        <!-- 更多筛选条件 -->
        <el-collapse-transition>
          <div v-show="dropStatus">
            <el-form-item label="要求发货日">
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="开始日期"
                  v-model="orderForm.start_out_ware_day"
                  style="width: 100%"
                />
              </el-col>
              <el-col class="line" :span="2">-</el-col>
              <el-col :span="11">
                <el-date-picker
                  type="date"
                  placeholder="结束日期"
                  v-model="orderForm.end_out_ware_day"
                  style="width: 100%"
                />
              </el-col>
            </el-form-item>

            <el-form-item label="快递单号" v-if="isZhifaOrFactory">
              <el-input v-model="orderForm.courierNumber" />
            </el-form-item>
            <el-form-item
              label="通知物流状态"
              v-if="isZhifa"
              label-width="90px"
            >
              <el-select
                v-model="orderForm.isTs"
                placeholder="请选择"
                clearable
              >
                <el-option label="通知中" :value="1"> </el-option>
                <el-option label="通知成功" :value="2"> </el-option>
                <el-option label="未通知" :value="3"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="是否生成箱码"
              label-width="80px"
              v-if="!isFactory"
            >
              <el-select
                v-model="orderForm.isBoxnum"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="1"> </el-option>
                <el-option label="否" :value="0"> </el-option>
              </el-select>
            </el-form-item>
            <!-- 2021 12 06 新增 是否紧急筛选项-->
            <el-form-item label="是否紧急订单" label-width="80px">
              <el-select
                v-model="orderForm.is_qp"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" :value="1"> </el-option>
                <el-option label="否" :value="0"> </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="物流状态"
              label-width="60px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.tsStatus"
                placeholder="仅筛选当前页面数据"
                clearable
              >
                <el-option
                  v-for="item in tsStatusList"
                  :label="item.text"
                  :value="item.value"
                  :key="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              label="物流通知方式"
              label-width="80px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.courier_type"
                placeholder="请选择"
                clearable
              >
                <el-option label="系统通知" :value="1" />
                <el-option label="非系统通知" :value="2" />
              </el-select>
            </el-form-item>
            <el-form-item
              label="物流单号更新状态"
              label-width="100px"
              v-if="isZhifa && statusActive === 4 && canInputTs"
            >
              <el-select
                v-model="orderForm.courier_odd_status"
                placeholder="请选择"
                clearable
              >
                <el-option label="更新中" :value="1"> </el-option>
                <el-option label="更新成功" :value="2"> </el-option>
                <el-option label="更新失败" :value="-1"> </el-option>
                <el-option label="更新失败(可重试)" :value="-2"> </el-option>
              </el-select>
            </el-form-item>
            <!-- 2024-04-25 新增订单类型(仅限参加定金购的商家)-->
            <el-form-item
              label="是否包含定金单"
              label-width="90px"
              v-if="
                isDeposit &&
                  statusActive !== 1 &&
                  statusActive !== 5 &&
                  statusActive !== 6
              "
            >
              <el-select
                v-model="orderForm.order_tag"
                placeholder="请选择"
                clearable
              >
                <el-option label="是" value="DEPOSIT_ORDER"> </el-option>
              </el-select>
            </el-form-item>
          </div>
        </el-collapse-transition>
        <el-form-item>
          <el-button type="primary" @click="searchOrderList" size="small"
            >查询</el-button
          >
          <el-button size="small" type="primary" @click="handleExport"
            >导出</el-button
          >
        </el-form-item>
      </el-form>
    </div>
    <!-- 查询表格结果 -->
    <div class="tableTitle">
      <span>查询结果：</span>
      <span class="info">提示：请及时接单,超时系统自动拒单</span>
      <div class="tableStatus">
        <!-- tab栏 -->
        <div class="tab-style">
          <div
            class="order-status"
            @click="getTableStatus(1)"
            :class="{ active: statusActive === 1 }"
          >
            <p>待接单({{ pendingOrder }})</p>
          </div>
          <div
            class="order-status"
            @click="getTableStatus(2)"
            :class="{ active: statusActive === 2 }"
          >
            <p>备货中({{ ordering }})</p>
          </div>
          <div
            class="order-status"
            @click="getTableStatus(3)"
            :class="{ active: statusActive === 3 }"
          >
            <p>已备货({{ readyOrder }})</p>
          </div>
          <div
            class="order-status"
            @click="getTableStatus(4)"
            :class="{ active: statusActive === 4 }"
          >
            <p>已出库({{ readyOut }})</p>
          </div>
          <div
            class="order-status"
            @click="getTableStatus(5)"
            :class="{ active: statusActive === 5 }"
          >
            <p>失效</p>
          </div>
          <!-- 2022-05-07 新增拒收订单tab isPingTai 账户存在 -->
          <div
            class="order-status"
            @click="getTableStatus(6)"
            :class="{ active: statusActive === 6 }"
            v-if="isPingTai"
          >
            <p>拒收订单</p>
          </div>
          <div
            v-if="statusActive == 4 && isPingTai"
            flex="main:center cross:center"
            style="margin-top: 5px; margin-left: 10px"
          >
            <el-checkbox
              v-model="orderForm.outware_timeout"
              @change="
                () => {
                  getTableStatus(4);
                }
              "
              >已出库超时未到分仓</el-checkbox
            >
          </div>
        </div>
        <!-- tab栏右边操作按钮 -->
        <div class="btns">
          <el-dropdown
            trigger="click"
            size="medium"
            placement="bottom"
            class="batchbtn"
            style="margin-left: 15px"
            @command="handleCommand"
            v-show="
              (statusActive === 4 && isZhifaOrFactory && canInputTs) ||
                (statusActive === 3 && isZhifaOrFactory && canInputTs)
            "
          >
            <el-button type="primary" size="small"> 录入物流运单 </el-button>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item command="b" :disabled="statusActive == 4"
                >录入全部</el-dropdown-item
              >
              <el-dropdown-item command="a">录入勾选</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
          <el-button
            size="small"
            type="primary"
            @click="quickSetBoxNum(false)"
            v-show="statusActive === 3 && !isFactory"
            class="blue"
            >快速订单打包</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="logisticsGetGoods(false)"
            v-show="statusActive === 3 && isZhifaOrFactory"
            v-if="!isFactory"
            >通知物流取货</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="acceptGoods"
            v-show="statusActive === 1"
            >接单</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 2"
            @click="printStockList"
            class="blue"
            >每日备货清单</el-button
          >

          <el-button
            size="small"
            type="primary"
            @click="autoPareDoneHandler"
            v-show="statusActive === 2"
            >备货完成</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 4"
            @click="completeGoods"
            >订单打包</el-button
          >

          <el-button
            size="small"
            type="primary"
            @click="outGoods(false)"
            v-if="!isFactory"
            v-show="statusActive === 3"
            >出库</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="factoryOutGoods('dialogCancel')"
            v-if="isFactory"
            v-show="statusActive === 3"
            >出库</el-button
          >
          <el-button
            size="small"
            type="primary"
            v-show="statusActive === 4 && !isZhifaOrFactory"
            @click="printOutwareList"
            >打印出库清单</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="cancelGoods"
            v-show="showCancelGoods"
            >取消备货</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="print(false)"
            v-show="statusActive === 3 && !isFactory"
            >打印全部箱码</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="exportGoodsListHandler"
            v-show="statusActive === 3"
            >导出货物清单</el-button
          >
          <el-button
            size="small"
            type="primary"
            @click="prinPurchaseHandler"
            v-show="statusActive === 3"
            v-if="isZhifaOrFactory"
            >打印采购订单</el-button
          >
          <!-- 已完成的状态 禁用 -->
          <el-button
            size="small"
            type="primary"
            @click="confirmRefuse"
            v-show="statusActive === 6"
            v-if="isPingTai"
            :disabled="
              selectOrderData.length > 0
                ? selectOrderData[0].status == 2
                  ? true
                  : false
                : false
            "
            >待确认拒收单</el-button
          >
        </div>
      </div>
    </div>
    <!-- table表格 -->
    <order-table
      ref="orderTable"
      v-loading="loadOrderTable"
      @getDetailTable="getDetailTable"
      @getTrackNo="getTrackNo"
      @getBoxData="getBoxData"
      @updateOrder="getOrderList"
      @getSelectOrderData="getSelectOrderData"
      @acceptGoodsOk="acceptGoodsOk"
      @editOrder="editOrderHandler"
      @getTransportDetail="getTransportDetail"
      @getDetailAsyncStatus="getDetailAsyncStatus"
      :orderTableData="orderTableData"
      :statusActive="statusActive"
    ></order-table>
    <order-print-table :orderTableData="orderTableData"></order-print-table>
    <!-- 分页 -->
    <el-pagination
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
      :current-page="currentPage"
      :page-sizes="[10, 50, 100, 200]"
      :page-size.sync="pagesize"
      layout="total, sizes, prev, pager, next, jumper"
      :total="totalCount"
    ></el-pagination>
    <!-- 商品信息、物流轨迹 -->
    <el-tabs type="card" v-model="activeName">
      <el-tab-pane label="商品信息" name="goods_info">
        <order-detail-table
          @updateOrder="getOrderList"
          :orderDetailTableData="orderDetailTableData"
          :statusActive="statusActive"
        ></order-detail-table>
      </el-tab-pane>
      <el-tab-pane
        label="物流轨迹"
        name="log_track"
        v-if="statusActive == 4 && isZhifaOrFactory"
      >
        <orderTrack
          ref="orderTrack"
          :order_id="current_row_id"
          :main_number="current_row_main_number"
          order_type="0"
        />
      </el-tab-pane>
      <el-tab-pane label="关联工单" name="as_work_order">
        <asWorkOrder
          type="order"
          :as_number="as_number"
          :randomNum="randomNum"
        />
      </el-tab-pane>
    </el-tabs>
    <!-- 弹出框 -->
    <order-dialog ref="orderDialog" :boxData="boxData"></order-dialog>
    <!-- 是否取消备货出库弹出框 -->
    <cancel-pare-dialog
      @cancelOrder="cancelOrder"
      ref="cancelPareDialog"
    ></cancel-pare-dialog>
    <!-- 已备货 编辑 导出货物清单 -->
    <delivery-sheet
      ref="deliverySheet"
      :id="selectOrderDataId"
      :ids="selectOrderData"
      v-if="showdeliverySheet"
      v-show="false"
    ></delivery-sheet>
    <!-- 取消订单提醒 弹出框 -->
    <order-cancel-dialog
      v-if="cancelOrderDialog"
      :dialog="cancelOrderDialog"
      :table="cancelDialogTable"
      @cancel="cancelDialogHandler"
      @confirm="cancelDialogConfirmHandler"
    ></order-cancel-dialog>
    <!-- xxx子订单详情 -->
    <transport-detail-dialog
      v-if="showTransportDetailDialog"
      :dialog="showTransportDetailDialog"
      :row="TransportDetailDialogRow"
      @cancel="() => (showTransportDetailDialog = false)"
    ></transport-detail-dialog>
    <el-dialog
      :visible.sync="printDialogVisible"
      :append-to-body="true"
      center
      width="500px"
    >
      <span slot="title" style="color: #fff">确认</span>
      <p>
        确认打印<span class="red-color-text">{{ selectOrderData.length }}</span
        >个订单，共<span class="red-color-text">{{ printBoxNumTotal }}</span
        >个打包箱数？
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="printDialogVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="print(true)" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      :visible.sync="notice"
      :append-to-body="true"
      top="25vh"
      center
      width="580px"
    >
      <span slot="title" style="color: #fff; font-size: 16px"
        >关于调整店铺管理系统箱码打印方式的通知</span
      >
      <p style="font-size: 16px">
        店铺管理系统的箱码打印方式调整，变更为浏览器打印。打印操作说明详见
        <a @click="goNotice" class="notice">【公告中心】-【打印指导】。</a>
      </p>
      <p style="font-size: 16px">调整生效时间：2019年9月5日20:00点。</p>
      <p style="text-align: right; font-weight: 600">锐锢商城</p>
      <p style="text-align: right; font-weight: 600">2019年9月5日</p>
    </el-dialog>
    <el-dialog
      :visible.sync="outGoodsDialog"
      :append-to-body="true"
      top="25vh"
      center
      width="580px"
    >
      <span slot="title" style="color: #fff; font-size: 16px">出库确认</span>
      <p>请确认是否出库</p>
      <p style="color: red; font-weight: bold">
        一旦出库，则订单无法再更改状态
      </p>
      <div slot="footer" class="dialog-footer">
        <el-button @click="outGoodsDialog = false" size="mini">取 消</el-button>
        <el-button
          type="primary"
          @click="factoryOutGoods('sureOut')"
          size="mini"
          >确 定</el-button
        >
      </div>
    </el-dialog>
    <boxcode ref="boxcode" v-show="false"></boxcode>
    <!-- 2021.06.01 同步信息弹窗 -->
    <el-dialog
      :visible.sync="orderSyncDialogVisible"
      :append-to-body="true"
      title="对接详情"
      width="580px"
    >
      <p>
        <span>批次号：</span><span>{{ orderSyncInfo.main_number }}</span>
      </p>
      <p>
        <span>同步时间：</span
        ><span>{{ orderSyncInfo.async_create_time }}</span>
      </p>
    </el-dialog>
    <el-dialog
      title="确认接单"
      :visible.sync="orderDialogVisible"
      :append-to-body="true"
      center
      width="400px"
    >
      <div class="hint">
        <div class="title">温馨提醒：</div>
        <div class="content">
          【备货中】主订单已有<span> {{ orderDialogData.readyOrder }} </span>单
        </div>
        <div class="content red-alert">
          为避免备货单量过大，建议<span>分批接单</span>
        </div>
        <div class="warning">
          注：备货中主订单单量，建议上限不要超过<span> 500 </span>单
        </div>
      </div>
      <div class="ask">
        已选择主订单<span> {{ orderDialogData.receiveOrder }} </span
        >单，确认接单？
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderDialogVisible = false" size="mini"
          >取 消</el-button
        >
        <el-button type="primary" @click="sureOrderDialog()" size="mini"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>
<script>
import { changeDateString, getOdStatusList } from "@/utils/utils";
import {
  getOrderList,
  listBox,
  getListWrongDetail, //失效订单
  getOrderDetail,
  printLogisticsSheet,
  getWrongOrder,
  outWare,
  exporOrdertData,
  autoPareDone,
  cancelOrderData,
  // getPurchaseList,
  batchPrintBoxCode,
  getFactoryOrderList,
  getR4MatchRefuseList,
  getR4MatchRefuseLisDetail,
  getBoxStatus, //物流状态枚举
  getNewList, //订单列表（直发|工厂）
  getShipStatusEnum
} from "@/models/orderModel";
import { courierStatusQuery } from "@/models/ts";
import orderTable from "@/components/order/order-table.vue";
import orderPrintTable from "@/components/order/order-print-table.vue";
import cancelPareDialog from "@/components/order/cancelPare-dialog.vue";
import orderDetailTable from "@/components/order/order-detail-table.vue";
import orderDialog from "@/components/order/order-status-dialog.vue";
import TransportDetailDialog from "@/components/order/TransportDetailDialog.vue";
import OrderCancelDialog from "@/components/order/OrderCancelDialog.vue";
import orderTrack from "@/components/order/order-track.vue"; //物流轨迹
import boxcode from "@/components/print/boxcode";
import asWorkOrder from "@/components/aftersale/work-order.vue"; //关联工单
import deliverySheet from "./delivery-sheet.vue";
import { eventBus } from "@/event-bus";
// import { error } from 'util'
// import { truncate } from 'fs'
import moment from "moment";
import Countdown from "@/utils/time";
import { loadOrderTotalnum } from "../../models/orderModel";
import { buildURL } from "@/utils/utils";
const tsStatusList = [
  { text: "新建", value: 1 },
  { text: "准备揽件", value: 2 },
  { text: "已取货", value: 3 },
  { text: "配送中", value: 4 },
  { text: "配送完成", value: 5 },
  { text: "非系统通知订单", value: 6 },
  { text: "取消", value: -1 }
];
// 推送时间-开始日期初始化为当前日期的半年前的1号（2023-08-16修改，因为一进页面数据量太大）
var initDate = new Date();
initDate.setMonth(initDate.getMonth() - 6); //修改月份
initDate.setDate(1); //日期设置为这个月的1号
initDate.setHours(0, 0, 0);

export default {
  components: {
    orderTable,
    orderPrintTable,
    orderDialog,
    orderDetailTable,
    cancelPareDialog,
    deliverySheet,
    OrderCancelDialog,
    TransportDetailDialog,
    boxcode,
    orderTrack,
    asWorkOrder
  },
  data() {
    return {
      orderDialogVisible: false, // 确认接单的弹框
      orderDialogData: {
        receiveOrder: 0,
        readyOrder: 0
      },
      tsStatusList,
      dropStatus: false,
      isZhifaOrFactory: false,
      isZhifa: false,
      isFactory: false,
      isPingTai: false,
      notice: false,
      showdeliverySheet: false, // 导出货物清单 不可见改元素
      orderForm: {
        main_number: "",
        order_number: "",
        start_created_at: new Date(initDate),
        end_created_at: "",
        start_out_ware_day: "",
        end_out_ware_day: "",
        instatus: "1",
        tsStatus: "",
        courier_type: "",
        courier_odd_status: "",
        is_ts: null,
        is_boxnum: null,
        outware_timeout: "",
        courier_mobile: "",
        // 主单状态
        mainOrderStatus: "",
        // 同步状态
        syncStatus: "",
        // 是否 紧急 1 是 0 否
        is_qp: null,
        box_status: "", //物流状态
        shipping_status: [], //报备状态
        as_number: "", //关联单号
        order_tag: "" //是否包含定金单
      },
      pagesize: 10,
      currentPage: 1,
      totalCount: 0,
      orderTableData: [],
      orderDetailTableData: [],
      // od_statusList: [],
      loadOrderTable: true,
      boxData: [],
      selectOrderDataId: "",
      selectOrderData: [],
      statusActive: 1,
      selectOrderNo: "",
      cancelOrderDialog: false, // 订单取消弹窗
      cancelDialogTable: {}, // 订单取消弹窗数据
      showTransportDetailDialog: false,
      orderSyncDialogVisible: false, // 订单同步状态弹窗
      orderSyncInfo: {}, // 订单同步状态信息
      TransportDetailDialogRow: {},
      printDialogVisible: false,
      printBoxNumTotal: 0,
      boxcodeList: [],
      showInputTs: false,
      canInputTs: false,
      outGoodsDialog: false, // 出库确认
      // 同步状态
      syncOptions: [],
      // 主单状态
      mainOrderOptions: [],
      logStatusOptions: {}, //物流状态
      // 同步状态是否显示
      syncStatusFlag: null,
      // 订单状态下的数量
      pendingOrder: 0, // 待接单
      ordering: 0, // 备货中
      readyOrder: 0, // 已备货
      readyOut: 0, // 已出库
      timer: {}, // 倒计时
      activeName: "goods_info", //默认展示商品信息
      current_row_id: undefined, //当前选中行id
      current_row_main_number: undefined, //当前选中行主单号
      as_number: undefined, //当前选中行主单号
      randomNum: Math.floor(Math.random() * 10 + 1),
      shipStatusOptions: {}, //报备状态
      isDeposit: localStorage.getItem("is_deposit")
    };
  },
  computed: {
    showCancelGoods() {
      return (
        this.statusActive === 3 ||
        (this.statusActive === 4 && localStorage.getItem("shop_type") === "0")
      );
    }
  },
  created() {
    // this.getHarfYear();
    let pageIndex = sessionStorage.getItem("order_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    if (localStorage.getItem("shop_type") === "2") {
      this.canInputTs = true;
      this.isFactory = true;
    }
    if (localStorage.getItem("shop_type") === "1") {
      this.isZhifa = true;
    }
    // 同步状态是否显示
    let syncStatusFlag = localStorage.getItem("syncStatus");
    if (syncStatusFlag !== "0") {
      this.syncStatusFlag = true;
    } else {
      this.syncStatusFlag = false;
    }
    this.initSelectData();
    // 从数据看板 超时未到分仓点击过来 显示已出库这个tab statusActive
    if (this.$route.query.statusActive) {
      this.orderForm.outware_timeout = true;
      this.getTableStatus(4);
    } else {
      this.getOrderTotalnum();
    }
  },
  mounted() {
    if (localStorage.getItem("shop_type") === "0") {
      this.isZhifaOrFactory = false;
      this.isPingTai = true;
    }
    if (
      localStorage.getItem("shop_type") === "1" ||
      localStorage.getItem("shop_type") === "2"
    ) {
      this.isZhifaOrFactory = true;
    }

    let pageIndex = sessionStorage.getItem("order_tab_index_pageIndex");
    if (pageIndex) {
      this.currentPage = Number(pageIndex);
    }
    if (localStorage.getItem("orderOutwareTimeout") == "1") {
      this.orderForm.outware_timeout = true;
    }
    let index = sessionStorage.getItem("order_tab_index") || 1;
    if (index) {
      this.getTableStatus(Number(index), true);
    }
    eventBus.$on("updateOrder", () => {
      this.getTableStatus(1);
    });

    if (localStorage.getItem("show_notice") === "1") {
      this.notice = false;
    } else {
      if (moment().format("YYYY-MM-DD") < "2019-09-11") {
        this.notice = true;
        localStorage.setItem("show_notice", "1");
      }
    }
  },
  methods: {
    getHarfYear() {
      var date = new Date();
      date.setMonth(date.getMonth() - 6); //修改月份
      date.setDate(1); //日期设置为这个月的1号
      // console.log("最终时间：", new Date(date));
      return new Date(date);
    },
    getOrderTotalnum() {
      const params = {
        is_timeout: this.orderForm.outware_timeout ? 1 : 0
      };
      loadOrderTotalnum(params)
        .then(res => {
          // console.log(res, "res");
          this.pendingOrder = res.djd;
          this.ordering = res.bhz;
          this.readyOrder = res.ybh;
          this.readyOut = res.yck;
        })
        .catch(err => {
          this.$message.error(err.message);
        });
    },
    moment,
    dropHandler() {
      this.dropStatus = !this.dropStatus;
    },
    goNotice() {
      this.$router.push({
        path: "/notice/printNotice"
      });
    },
    // 初始筛选项 下拉数据
    initSelectData() {
      this.mainOrderOptions = getOdStatusList().mo_statusList;
      this.syncOptions = getOdStatusList().syncStatuslist;
      this.getTrackStatus();
      this.getShipStatus();
    },
    // 获取物流状态枚举
    async getTrackStatus() {
      const res = await getBoxStatus();
      this.logStatusOptions = res || {};
    },
    // 获取报备状态枚举
    async getShipStatus() {
      const res = await getShipStatusEnum();
      this.shipStatusOptions = res || {};
    },

    // 导出
    handleExport() {
      if (this.isZhifaOrFactory) {
        this.exportOrderZF();
      } else {
        this.exportOrder();
      }
    },
    // 直发|工厂 导出
    async exportOrderZF() {
      const {
        main_number,
        order_number,
        instatus,
        serialNumber,
        courierNumber,
        is_qp,
        mainOrderStatus,
        syncStatus,
        start_created_at,
        end_created_at,
        start_out_ware_day,
        end_out_ware_day,
        isTs,
        isBoxnum,
        courier_odd_status,
        courier_type,
        courier_mobile,
        box_status
      } = this.orderForm;

      let params = {
        main_number, //主订单号
        order_number, //子订单号
        instatus, //
        page: this.currentPage,
        page_size: this.pagesize,
        serial_number: serialNumber, //编号
        courier_number: courierNumber, //快递单号
        order_type: 0,
        // 新增 (是否紧急入参) 2021 12 08
        is_qp, //是否紧急订单
        mo_status: mainOrderStatus, //主单状态
        sync_status: syncStatus, //同步状态
        is_export: 1 //导出
      };

      if (
        this.isDeposit &&
        this.statusActive !== 1 &&
        this.statusActive !== 5 &&
        this.statusActive !== 6
      ) {
        params.order_tag = this.orderForm.order_tag;
      }
      if (this.statusActive == 4) {
        params.box_status = box_status; //物流状态（包裹状态）
      }
      //推送日期
      if (start_created_at) {
        this.loadOrderTable = true;
        params.start_created_at = changeDateString(start_created_at);
      }
      if (end_created_at) {
        params.end_created_at = changeDateString(end_created_at);
      }
      // 要求发货日
      if (start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (end_out_ware_day) {
        params.end_out_ware_day = changeDateString(end_out_ware_day).replace(
          "00:00:00",
          ""
        );
      }
      if (typeof isTs === "number") {
        params.is_ts = isTs; //通知物流状态
      }
      if (typeof isBoxnum === "number") {
        params.is_boxnum = isBoxnum; //是否生成箱码
      }
      if (typeof courier_odd_status === "number") {
        params.courier_odd_status = courier_odd_status;
      }
      if (typeof courier_type === "number") {
        params.courier_type = courier_type;
      }
      if (this.orderForm.outware_timeout && this.orderForm.instatus == "5,6") {
        params.outware_timeout = 1;
      }
      if (
        (this.statusActive === 4 && this.isZhifaOrFactory && this.canInputTs) ||
        (this.statusActive === 3 && this.isZhifaOrFactory && this.canInputTs)
      ) {
        params.courier_mobile = courier_mobile; //物流联系电话
      }
      const url = `${echarthostname}/system/order/list/?access_token=${localStorage.getItem(
        "token"
      )}&shop_id=${localStorage.getItem("shop_id")}&${buildURL(params)}`;
      window.open(url);
    },
    // 导出 邮箱中查收
    async exportOrder() {
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus
      };
      if (
        this.isDeposit &&
        this.statusActive !== 1 &&
        this.statusActive !== 5 &&
        this.statusActive !== 6
      ) {
        params.order_tag = this.orderForm.order_tag;
      }
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.statusActive === 5) {
        params.status = "-1";
      } else {
        params.status = "1";
      }
      await exporOrdertData(params);
    },
    // 每日备货清单
    printStockList() {
      this.$router.push("/order/dayStockList");
    },
    // 打印出库清单
    printOutwareList() {
      // if (this.ifSelectData()) {
      this.$router.push("/order/shippingList");
      // }
    },
    getTableStatus(index, isReturnBack) {
      this.clearTimer();
      this.getOrderTotalnum();
      if (!isReturnBack) {
        this.currentPage = 1;
        sessionStorage.setItem("order_tab_index_pageIndex", 1);
      }
      this.statusActive = index;
      sessionStorage.setItem("order_tab_index", index);
      this.orderDetailTableData = [];

      this.pagesize = 10;
      switch (index) {
        case 1:
          this.orderForm.instatus = "1";
          break;
        case 2:
          this.orderForm.instatus = "2";
          break;
        case 3:
          this.orderForm.instatus = "3,4";
          break;
        case 4:
          this.orderForm.instatus = "5,6";
          break;
        case 5:
          this.orderForm.instatus = "-1";
          break;
      }
      this.getOrderList();
      //物流轨迹 清除已选中的数据
      this.current_row_id = undefined;
      this.current_row_main_number = undefined;
    },
    // 获取选择的订单 勾选
    getSelectOrderData(val) {
      this.showdeliverySheet = false;
      this.selectOrderData = val;
      if (this.statusActive === 1 && val.length !== 0) {
        let listId = [];
        let listNo = [];
        val.forEach((n, i) => {
          listId.push(n.id);
          listNo.push(n.main_number);
        });
        this.selectOrderDataId = listId.join(",");
        this.selectOrderNo = listNo.join(",");
      } else if (val.length !== 0) {
        this.selectOrderDataId = val[0].id;
        this.selectOrderNo = val[0].main_number;
      }
    },
    // 勾选数据
    ifSelectData() {
      if (!this.selectOrderData || this.selectOrderData.length === 0) {
        this.$message.warning("请勾选列表");
        return false;
      } else {
        return true;
      }
    },
    // 接单
    // =============== 2021-10-28 增加接单二次确认的弹框
    acceptGoods() {
      if (this.ifSelectData()) {
        let params = {
          main_number: this.orderForm.main_number,
          order_number: this.orderForm.order_number,
          instatus: 2,
          page: this.currentPage,
          pagesize: this.pagesize,
          serial_number: this.orderForm.serialNumber,
          courier_number: this.orderForm.courierNumber,
          order_type: 0,
          mo_status: this.orderForm.mainOrderStatus,
          sync_status: this.orderForm.syncStatus
        };
        // 新增 部分分仓  2022-10-10
        if (this.orderForm.mainOrderStatus == "6_1") {
          params.mo_status = 6;
          params.is_part = 1;
        } else {
          params.mo_status = this.orderForm.mainOrderStatus;
        }
        if (this.orderForm.start_created_at) {
          this.loadOrderTable = true;
          params.start_created_at = changeDateString(
            this.orderForm.start_created_at
          );
        }
        if (this.orderForm.end_created_at) {
          params.end_created_at = changeDateString(
            this.orderForm.end_created_at
          );
        }
        getOrderList(params)
          .then(res => {
            // console.log(res);
            this.orderDialogData.readyOrder = res.total;
          })
          .catch(err => {
            this.$message.error(err.message);
          });
        this.orderDialogData.receiveOrder = this.selectOrderDataId.split(
          ","
        ).length;
        this.orderDialogVisible = true;
      }
    },
    // 接单的二次确认
    sureOrderDialog() {
      this.orderDetailTableData = [];
      this.$refs.orderTable.acceptGoods(this.selectOrderDataId);
      this.orderDialogVisible = false;
    },
    // 接单成功进入备货中  不跳转
    acceptGoodsOk() {},
    // 订单打包
    completeGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能选择一个");
        } else {
          localStorage.setItem(
            "orderData",
            JSON.stringify(this.selectOrderData)
          );
          if (
            (this.statusActive === 3 &&
              localStorage.getItem("shop_type") === "1") ||
            localStorage.getItem("shop_type") === "2"
          ) {
            // 已备货且为直发可以通知物流取货
            this.$router.push({
              path: "/order/completeStock",
              query: { id: this.selectOrderDataId, showLogisticsSheet: "true" }
            });
          } else {
            this.$router.push({
              path: "/order/completeStock",
              query: { id: this.selectOrderDataId }
            });
          }
        }
        // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      }
    },
    // 已备货页签 编辑订单
    editOrderHandler(id) {
      // if (this.ifSelectData()) {
      localStorage.setItem("orderData", JSON.stringify(this.selectOrderData));
      if (
        (this.statusActive === 3 &&
          localStorage.getItem("shop_type") === "1") ||
        localStorage.getItem("shop_type") === "2"
      ) {
        // 已备货且为直发可以通知物流取货
        this.$router.push({
          path: "/order/completeStock",
          query: { id: id, showLogisticsSheet: "true" }
        });
      } else {
        this.$router.push({ path: "/order/completeStock", query: { id: id } });
      }
      // this.$refs.orderTable.completeGoods(this.selectOrderDataId)
      // }
    },
    // 取消备货
    cancelGoods() {
      if (this.ifSelectData()) {
        if (this.selectOrderData.length > 1) {
          this.$message.warning("只能勾选一个");
        } else {
          this.$refs.cancelPareDialog.cancelPareVisible = true;
          this.$refs.cancelPareDialog.orderNoGroups = this.selectOrderNo;
        }
      }
    },
    cancelOrder() {
      this.$refs.orderTable.cancelGoods(this.selectOrderDataId);
    },
    // 出库 next =false 平台需要确认弹窗
    async outGoods(next, isFactoryConfirm) {
      // 直发
      if (this.isZhifa) {
        if (localStorage.getItem("need_scan") === "0") {
          // 不需要扫描
          if (this.selectOrderData.length >= 1) {
            let arr = [];
            this.selectOrderData.forEach(item => {
              arr.push(item.id);
            });

            let params = {
              ids: arr.join(",")
            };
            let data = await outWare(params);
            if (data.message === "Success") {
              this.getOrderList();
            }
          } else {
            this.$message.warning("请勾选列表");
          }
        } else {
          this.$router.push("/order/scanningStock");
        }
        return;
      }

      // 平台
      if (!next) {
        cancelOrderData({
          ids: ""
        }).then(res => {
          if (res.code === 200) {
            if (res.data.detail_count < 1) {
              this.outGoods(true);
            } else {
              this.cancelDialogTable = res.data;
              this.cancelOrderDialog = true;
            }
          }
        });
      } else {
        if (localStorage.getItem("need_scan") === "0") {
          // 不需要扫描
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(",")
          };
          let data = await outWare(params);
          if (data.message === "Success") {
            this.getOrderList();
          }
        } else {
          this.$router.push("/order/scanningStock");
        }
      }
    },
    // 出库 工厂
    async factoryOutGoods(val) {
      if (localStorage.getItem("need_scan") === "0") {
        // 不需要扫描
        if (this.selectOrderData.length >= 1) {
          // 订单取消提醒弹窗
          if (val === "dialogCancel") {
            cancelOrderData({
              ids: this.selectOrderData
                .map(item => {
                  return item.id;
                })
                .join(",")
            }).then(res => {
              if (res.code === 200) {
                if (res.data.detail_count < 1) {
                  this.factoryOutGoods("confirm");
                } else {
                  this.cancelDialogTable = res.data;
                  this.cancelOrderDialog = true;
                }
              }
            });
            return;
          }
          // 确认提醒弹窗
          if (val === "confirm") {
            this.outGoodsDialog = true;
            return;
          }
          // 出库
          if (val === "sureOut") {
            let arr = [];
            this.selectOrderData.forEach(item => {
              arr.push(item.id);
            });
            let params = {
              ids: arr.join(",")
            };
            let data = await outWare(params);
            if (data.message === "Success") {
              this.getOrderList();
            }
            this.outGoodsDialog = false;
            this.cancelOrderDialog = false;
          }
        } else {
          this.$message.warning("请勾选列表");
        }
      } else {
        this.$router.push("/order/scanningStock");
      }
    },
    // 获取单条订单详情
    async getDetailTable(row) {
      let params;
      let data;
      if (this.statusActive === 5) {
        params = {
          id: row.mo_id
        };
        data = await getWrongOrder(params);
      } else if (this.statusActive === 6) {
        // R4自配拒收订单 详情
        params = {
          re_order_id: row.id
        };
        data = await getR4MatchRefuseLisDetail(params);
      } else {
        params = {
          id: row.id
        };
        data = await getOrderDetail(params);
      }
      if (this.statusActive !== 6) {
        for (let i of data) {
          i.mo_statusName = getOdStatusList().statusList.filter(
            item => item.value === i.status
          )[0].label;
        }
      }
      this.orderDetailTableData = data;
      let orderNo = [];
      data.map(item => {
        orderNo.push(item.order_number);
      });
      this.as_number = orderNo;
      this.$nextTick(() => {
        this.randomNum = Math.floor(Math.random() * 10 + 1);
      });
    },
    // 获取单条订单号（为了获取订单物流轨迹）2022-10-17
    getTrackNo(row) {
      this.current_row_id = row.id;
      this.current_row_main_number = row.main_number;
    },
    async getBoxData(row) {
      // console.log(this.statusActive);
      let params = { id: row.id };
      let data = await listBox(params);
      this.boxData = data;
      if (data) {
        for (let i of data) {
          // 已出库tab下 点击打包箱数时 弹框的到达状态做区分
          if (this.statusActive === 4) {
            if (i.status === "2") {
              i.status = "已到分仓";
            } else if (i.status === "1") {
              i.status = "已出库";
            }
          } else {
            i.status = row.od_statusName;
          }
        }
        this.$refs.orderDialog.boxDialogVisible = true;
        this.$refs.orderDialog.orderNo = `主订单号：${row.main_number}`;
      }
    },
    // 打印箱码
    async print(val) {
      if (this.ifSelectData()) {
        if (!val) {
          this.printDialogVisible = true;
          let boxNumTotal = [];
          this.selectOrderData.forEach(item => {
            if (item.box_num) {
              boxNumTotal.push(item.box_num);
            }
          });
          this.printBoxNumTotal = boxNumTotal
            .reduce((pre, curr) => {
              return Number(pre) + Number(curr);
            }, 0)
            .toFixed(0);
        } else {
          // this.$refs.orderTable.print(this.selectOrderData)
          let boxcodeList = [...this.selectOrderData];
          let ids = [];
          let failedData = [];
          boxcodeList.forEach(item => {
            ids.push(item.id);
          });
          let params = {
            ids: JSON.stringify(ids)
          };
          let res = await batchPrintBoxCode(params);
          if (res.code === 200) {
            let success = res.data.succeed;
            failedData = res.data.failed;
            if (failedData.length > 0) {
              failedData.forEach(item => {
                item.main_number = boxcodeList.find(order => {
                  return order.id === item.id;
                }).main_number;
              });
              let html = "";
              failedData.forEach(item => {
                html +=
                  '<p style="padding:5px;">主订单号：' +
                  item.main_number +
                  "," +
                  item.msg +
                  "</p>";
              });
              this.$message({
                showClose: true,
                type: "error",
                iconClass: "11",
                dangerouslyUseHTMLString: true,
                message: html,
                duration: 0
              });
            } else {
              let printData = [];

              for (const key in success) {
                if (success.hasOwnProperty(key)) {
                  let item = success[key];
                  for (let i of item) {
                    i.code = i.serial_number;
                    i.print_interval = 5;

                    printData.push(i);
                  }
                }
              }
              this.$refs.boxcode.myPrint(printData);
              this.printDialogVisible = false;
            }
          }
          // this.boxcodeList = boxcodeList
          // console.log(boxcodeList, 'this.selectOrderData')
          // this.$refs.boxcode.myPrint(boxcodeList)
          // this.printDialogVisible = false
        }
      }
    },

    // 搜索
    searchOrderList() {
      this.currentPage = 1;
      this.getOrderList();
    },
    // 平台获取订单列表
    async getCommonOrderList() {
      const shipStatus = this.orderForm.shipping_status;
      this.loadOrderTable = true;
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus,
        serial_number: this.orderForm.serialNumber,
        order_type: 0,
        // 新增 (是否紧急入参) 2021 12 08
        is_qp: this.orderForm.is_qp,
        mo_status: this.orderForm.mainOrderStatus,
        sync_status: this.orderForm.syncStatus,
        shipping_delay_status:
          shipStatus && shipStatus.length ? shipStatus.join(",") : undefined,
        page: this.currentPage,
        page_size: this.pagesize
      };
      //推送日期
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      // 要求发货日
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isBoxnum === "number") {
        params.is_boxnum = this.orderForm.isBoxnum; //是否生成箱码
      }
      if (this.orderForm.outware_timeout && this.orderForm.instatus == "5,6") {
        params.outware_timeout = 1;
      }
      // 定金购活动商家加查询参数：是否定金单
      if (this.isDeposit) {
        params.order_tag = this.orderForm.order_tag;
      }
      // let data = await getOrderList(params);
      let data = await getNewList(params);
      let list = data.list || [];
      this.orderTableData = list;
      this.totalCount = data.total;
      // 设置单据状态
      for (let i of this.orderTableData) {
        i.od_statusName = i.mo_status_str;
        i.async_create_statusName = i.sync_status_str; // 同步状态

        i.box_status_msg = i.box_status.msg; // 物流状态
        i.mobile = i.user_mobile; //客户电话
        i.address = i.user_address; //客户地址
        i.express = i.courier_name; //快递名称
      }
      this.loadOrderTable = false;
    },
    // 工厂获取订单列表
    async getFactoryOrderData() {
      this.loadOrderTable = true;
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus,
        page: this.currentPage,
        pagesize: this.pagesize,
        serial_number: this.orderForm.serialNumber,
        courier_number: this.orderForm.courierNumber,
        order_type: 0,
        // 新增 (是否紧急入参) 2021 12 08
        is_qp: this.orderForm.is_qp
      };
      if (this.orderForm.start_created_at) {
        this.loadOrderTable = true;
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isTs === "number") {
        params.is_ts = this.orderForm.isTs;
      }
      if (typeof this.orderForm.isBoxnum === "number") {
        params.is_boxnum = this.orderForm.isBoxnum;
      }
      if (typeof this.orderForm.courier_odd_status === "number") {
        params.courier_odd_status = this.orderForm.courier_odd_status;
      }
      if (typeof this.orderForm.courier_type === "number") {
        params.courier_type = this.orderForm.courier_type;
      }
      if (
        (this.statusActive === 4 && this.isZhifaOrFactory && this.canInputTs) ||
        (this.statusActive === 3 && this.isZhifaOrFactory && this.canInputTs)
      ) {
        params.courier_mobile = this.orderForm.courier_mobile;
      }
      let data = await getFactoryOrderList(params);
      let list = data.list || [];
      if (this.statusActive === 4 && this.isZhifaOrFactory && this.canInputTs) {
        list.forEach(item => {
          item.ts_status = "";
        });
      }
      this.orderTableData = list;
      this.totalCount = data.total;
      // 设置单据状态
      for (let i of this.orderTableData) {
        let odStatusName = getOdStatusList().mo_statusList.filter(item => {
          return item.value === i.mo_status;
        });
        if (odStatusName.length === 0) {
          i.od_statusName = "其他";
        } else {
          i.od_statusName = odStatusName[0].label;
        }
      }
      this.loadOrderTable = false;
    },
    // 直发|工厂获取订单列表
    async getNewOrderData() {
      this.loadOrderTable = true;
      const {
        main_number,
        order_number,
        instatus,
        serialNumber,
        courierNumber,
        is_qp,
        mainOrderStatus,
        syncStatus,
        start_created_at,
        end_created_at,
        start_out_ware_day,
        end_out_ware_day,
        isTs,
        isBoxnum,
        courier_odd_status,
        courier_type,
        courier_mobile,
        box_status,
        shipping_status,
        order_tag
      } = this.orderForm;

      let params = {
        main_number, //主订单号
        order_number, //子订单号
        instatus, //
        serial_number: serialNumber, //编号
        courier_number: courierNumber, //快递单号
        order_type: 0,
        // 新增 (是否紧急入参) 2021 12 08
        is_qp, //是否紧急订单
        mo_status: mainOrderStatus, //主单状态
        sync_status: syncStatus, //同步状态
        shipping_delay_status:
          shipping_status && shipping_status.length
            ? shipping_status.join(",")
            : undefined,
        page: this.currentPage,
        page_size: this.pagesize
      };
      if (this.statusActive == 4) {
        params.box_status = box_status; //物流状态（包裹状态）
      }
      //推送日期
      if (start_created_at) {
        this.loadOrderTable = true;
        params.start_created_at = changeDateString(start_created_at);
      }
      if (end_created_at) {
        params.end_created_at = changeDateString(end_created_at);
      }
      // 要求发货日
      if (start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (end_out_ware_day) {
        params.end_out_ware_day = changeDateString(end_out_ware_day).replace(
          "00:00:00",
          ""
        );
      }
      if (typeof isTs === "number") {
        params.is_ts = isTs; //通知物流状态
      }
      if (typeof isBoxnum === "number") {
        params.is_boxnum = isBoxnum; //是否生成箱码
      }
      if (typeof courier_odd_status === "number") {
        params.courier_odd_status = courier_odd_status;
      }
      if (typeof courier_type === "number") {
        params.courier_type = courier_type; // 物流通知方式（直发）
      }
      if (this.orderForm.outware_timeout && this.orderForm.instatus == "5,6") {
        params.outware_timeout = 1;
      }
      if (
        (this.statusActive === 4 && this.canInputTs) ||
        (this.statusActive === 3 && this.canInputTs)
      ) {
        params.courier_mobile = courier_mobile; //物流联系电话
      }
      if (this.isDeposit) {
        params.order_tag = order_tag;
      }
      let data = await getNewList(params);
      // console.log("data-list:", data);
      let list = data.list || [];
      // }
      this.orderTableData = list;
      this.totalCount = data.total;
      for (let i of this.orderTableData) {
        i.od_statusName = i.mo_status_str;
        i.async_create_statusName = i.sync_status_str; // 同步状态

        i.box_status_msg = i.box_status.msg; // 物流状态
        i.mobile = i.user_mobile; //客户电话
        i.address = i.user_address; //客户地址
        i.express = i.courier_name; //快递名称
      }
      this.loadOrderTable = false;
    },
    // 获取失效订单
    async getListWrongDetail(isReturnBack) {
      this.loadOrderTable = true;
      let params = {
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number,
        instatus: this.orderForm.instatus,
        page: this.currentPage,
        pagesize: this.pagesize,
        serial_number: this.orderForm.serialNumber,
        courier_number: this.orderForm.courierNumber,
        order_type: 0,
        // 新增 (是否紧急入参) 2021 12 08
        is_qp: this.orderForm.is_qp
      };
      if (this.orderForm.start_created_at) {
        params.start_created_at = changeDateString(
          this.orderForm.start_created_at
        );
      }
      if (this.orderForm.end_created_at) {
        params.end_created_at = changeDateString(this.orderForm.end_created_at);
      }
      if (this.orderForm.start_out_ware_day) {
        params.start_out_ware_day = changeDateString(
          this.orderForm.start_out_ware_day
        ).replace("00:00:00", "");
      }
      if (this.orderForm.end_out_ware_day) {
        params.end_out_ware_day = changeDateString(
          this.orderForm.end_out_ware_day
        ).replace("00:00:00", "");
      }
      if (typeof this.orderForm.isTs === "number") {
        params.is_ts = this.orderForm.isTs;
      }
      if (typeof this.orderForm.isBoxnum === "number") {
        params.is_boxnum = this.orderForm.isBoxnum;
      }
      let data = await getListWrongDetail(params);
      data.list.forEach(item => {
        item.total_amount = item.amount; // 订购总量
        item.total_send_amount = ""; // total_send_amount
        // item.total_send_amount = item.send_amount // total_send_amount
        if (item.price) {
          if (item.amount) {
            // 订单总金额
            item.total_price = (item.amount * item.price).toFixed(2);
          }
          if (item.send_amount) {
            // 实发总金额
            // item.total_send_price = (item.send_amount * item.price).toFixed(2)
            item.total_send_price = "";
          }
        }
      });
      this.statusActive = 5;
      this.orderTableData = data.list;
      for (let i of this.orderTableData) {
        i.od_statusName = getOdStatusList().mo_statusList.filter(item => {
          return item.value === i.status;
        })[0].label;
      }
      this.totalCount = data.total;
      this.loadOrderTable = false;
    },
    // isReturnBack 是否从其他位置返回该页面
    async getOrderList(isReturnBack) {
      if (
        localStorage.getItem("shop_type") === "0" ||
        localStorage.getItem("shop_type") === "1"
      ) {
        if (this.statusActive === 5) {
          this.getListWrongDetail(isReturnBack);
        } else if (this.statusActive === 6) {
          // 平台店铺 R4 自配拒单列表
          this.initR4MatchRefuseList();
        } else {
          if (localStorage.getItem("shop_type") === "0") {
            this.getCommonOrderList(isReturnBack);
          }
        }
      }
      if (
        localStorage.getItem("shop_type") === "2" &&
        this.statusActive === 5
      ) {
        this.getListWrongDetail(isReturnBack);
      }
      // 工厂|直发 订单列表(失效订单除外)
      if (
        (localStorage.getItem("shop_type") === "1" ||
          localStorage.getItem("shop_type") === "2") &&
        this.statusActive !== 5
      ) {
        this.getNewOrderData();
      }
    },
    // 获取R4 自配拒单列表数据
    async initR4MatchRefuseList() {
      this.loadOrderTable = true;
      let params = {
        shop_id: localStorage.getItem("shop_id"),
        as_number: this.orderForm.as_number,
        main_number: this.orderForm.main_number,
        order_number: this.orderForm.order_number
      };
      let res = await getR4MatchRefuseList(params);
      res.list.map(item => {
        // 倒计时结束日期计算
        // to_wh_time 拒收时间 时间第二天 的 00:00:00  往后计算3天 72小时
        if (item.to_wh_time) {
          // 倒计时 开始时间点
          let currentStartTime = moment(item.to_wh_time)
            .add(1, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          // 倒计时 结束时间点
          let lastEndTime = moment(currentStartTime)
            .add(3, "days")
            .startOf("day")
            .format("YYYY-MM-DD HH:mm:ss");
          item.currentStartTime = currentStartTime;
          item.lastEndTime = lastEndTime;
          item.timer = "";
          item.showTime = "";
        } else {
          item.currentStartTime = "";
          item.lastEndTime = "";
          item.timer = "";
          item.showTime = "";
        }
      });
      this.orderTableData = res.list;
      if (this.isPingTai && this.statusActive === 6) {
        this.countdownTable(this.orderTableData);
      }
      this.loadOrderTable = false;
      this.totalCount = res.total;
    },
    serachOrder() {},
    // 每页条数改变
    handleSizeChange(val) {
      this.pagesize = val;
      this.getOrderList();
    },
    // 页码改变
    handleCurrentChange(val) {
      sessionStorage.setItem("order_tab_index_pageIndex", val);
      this.currentPage = val;
      this.getOrderList();
    },
    // 备货完成
    autoPareDoneHandler() {
      if (this.selectOrderData.length > 0) {
        let arr = [];
        this.selectOrderData.forEach(item => {
          arr.push(item.id);
        });
        autoPareDone({ ids: arr.join(",") }).then(res => {
          if (res.code === 200) {
            this.getOrderList();
          }
        });
      } else {
        this.$message.warning("请勾选列表");
      }
    },
    // 导出货物清单
    exportGoodsListHandler() {
      if (this.ifSelectData()) {
        this.showdeliverySheet = true;
        this.$nextTick(function() {
          this.$refs.deliverySheet.print();
        });
        console.log(this.selectOrderData, "selectOrderDataId");
      }
    },
    // 通知物流取货
    async logisticsGetGoods(next) {
      if (this.ifSelectData()) {
        if (!next) {
          cancelOrderData({
            ids: this.selectOrderData
              .map(item => {
                return item.id;
              })
              .join(",")
          }).then(res => {
            if (res.code === 200) {
              if (res.data.detail_count < 1) {
                this.logisticsGetGoods(true);
              } else {
                this.cancelDialogTable = res.data;
                this.cancelOrderDialog = true;
              }
            }
          });
        } else {
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          let params = {
            ids: arr.join(",")
          };
          let res = await printLogisticsSheet(params);
          if (res.code === 200) {
            let data = res.data;
            if (data.length === 0) {
              this.$message.warning(
                "已发送请求，通知物流结果在2-3分钟后返回,可刷新页面查看"
              );
              this.getOrderList();
            } else {
              let htmlStr =
                '<p style="padding:5px;color:red;">通知物流结果在2-3分钟后返回,可刷新页面查看</p>';
              this.orderTableData.forEach(item => {
                data.forEach(erritem => {
                  if (item.id === erritem.id) {
                    htmlStr += `<p style="padding:5px;color:#000;">${item.main_number}:${erritem.msg}</p>`;
                  }
                });
              });
              this.$message({
                dangerouslyUseHTMLString: true,
                duration: 5000,
                message: htmlStr,
                type: "error",
                showClose: true
              });
              this.getOrderList();
            }
          } else {
            this.$message.error(res.message);
          }
        }
      }
    },
    // 取消订单提醒弹窗
    cancelDialogHandler() {
      this.cancelOrderDialog = false;
    },
    // 确认订单出库提醒
    cancelDialogConfirmHandler() {
      if (this.isZhifa) {
        // 直发
        this.logisticsGetGoods(true);
        this.cancelOrderDialog = false;
        return;
      }
      if (this.isFactory) {
        // 工厂
        this.factoryOutGoods("confirm");

        return;
      }
      // 平台
      this.outGoods(true);
      this.cancelOrderDialog = false;
    },
    // 打印采购订单
    prinPurchaseHandler() {
      this.$router.push("/order/prinPurchase");
    },
    // 查看子单号
    getTransportDetail(row) {
      this.showTransportDetailDialog = true;
      this.TransportDetailDialogRow = row;
    },
    // 查看同步状态信息
    getDetailAsyncStatus(row) {
      this.orderSyncDialogVisible = true;
      this.orderSyncInfo = {
        main_number: row.main_number,
        async_create_time: row.async_create_time
      };
    },
    // 快速设置打包
    quickSetBoxNum() {
      if (this.ifSelectData()) {
        this.$router.push({
          path: "/order/QuickSetBoxNum",
          query: {
            params: this.selectOrderData
          }
        });
      }
    },
    // 录入物流运单
    handleCommand(val) {
      if (val === "b") {
        this.inputTsHandler("all");
      }
      if (val === "a") {
        this.inputTsHandler();
      }
    },
    // 录入物流运单
    inputTsHandler(status) {
      if (status === "all") {
        // console.log("orderTable:", this.orderTableData);
        this.$router.push({
          name: "inputTS",
          params: {
            ids: "",
            orderType: this.orderForm.instatus,
            isAll: "YES"
          }
        });
      } else {
        if (this.selectOrderData.length > 0) {
          let arr = [];
          this.selectOrderData.forEach(item => {
            arr.push(item.id);
          });
          this.$router.push({
            name: "inputTS",
            params: {
              ids: JSON.stringify(arr.join(",")),
              orderType: this.orderForm.instatus,
              isAll: "NO"
            }
          });
        } else {
          this.$message.warning("请选择订单");
        }
      }
    },
    // 确认拒收单
    confirmRefuse() {
      if (this.selectOrderData.length === 1) {
        this.$router.push({
          path: "/order/matchRefuse",
          query: {
            re_order_id: this.selectOrderData[0].id
          }
        });
      } else if (this.selectOrderData.length > 1) {
        this.$message.warning("只能选择一个");
      } else {
        this.$message.warning("请勾选订单");
      }
    },
    // 计时
    countdownTable(arr) {
      let vm = this;
      arr.forEach((item, index) => {
        if (item.currentStartTime && item.lastEndTime) {
          // 当前时间
          const currentTime = moment().format("YYYY-MM-DD HH:mm:ss");
          // 当前时间是否在倒计时开始时间前
          const flag = moment(currentTime).isBefore(item.currentStartTime);
          // 当前时间是否在倒计时结束时间前
          const flag1 = moment(currentTime).isBefore(item.lastEndTime);
          // 当前时间 在倒计时开始时间后 在倒计时结束时间之前
          if (flag == false && flag1 == true) {
            this.countdown(currentTime, item.lastEndTime, index);
          }
          // 当前时间 在倒计时开始时间之前 则不开启倒计时 倒计时时间差最多72小时
          if (flag == true) {
            vm.$set(vm.orderTableData[index], "showTime", "");
          }
          // 当前时间 不在倒计时结束时间之前
          if (flag1 == false) {
            vm.$set(vm.orderTableData[index], "showTime", "00:00:00");
          }
        }
      });
    },
    // 生成计时
    countdown(time, now, index) {
      let vm = this;
      let retime = new Countdown(time, now);
      let callback = (val, timer) => {
        vm.$set(vm.orderTableData[index], "showTime", val);
        this.timer[timer] = timer;
      };
      retime.goAfter(callback);
    },
    // 清除计时
    clearTimer() {
      for (const interval of Object.values(this.timer)) {
        clearInterval(interval);
      }
    },
    beforeDestroy: function() {
      // 离开路由前清除定时器
      this.clearTimer();
    }
  }
};
</script>
<style lang="scss">
.order {
  .el-form .el-form-item__label {
    width: 65px;
    white-space: nowrap;
  }
  .el-button.blue {
    color: #409eff;
    background-color: #409eff;
    border-color: #409eff;
    color: #fff;
  }
  .tableTitle {
    margin-bottom: 2px;
    margin-top: 10px;
    padding-top: 5px;
    border-top: 1px solid #ddd;
    span {
      font-size: 12px;
    }
    .info {
      color: red;
    }
    .tableStatus {
      display: flex;
      justify-content: space-between;
      div {
        display: flex;
      }
      .tab-style {
        width: 100%;
      }
      .order-status {
        cursor: pointer;
        height: 30px;
        min-width: 80px;
        margin-right: 1px;
        margin-top: 5px;
        border-radius: 8px 8px 0px 0px;
        background-color: rgb(115, 129, 140);
        p {
          color: #fff;
          font-size: 14px;
          width: 100%;
          text-align: center;
          line-height: 4px;
        }
      }
      .order-status.active,
      .order-status:hover {
        background-color: rgb(164, 180, 193);
      }
    }
    p {
      line-height: 10px;
    }
    .btns {
      margin-top: 5px;
      .editBtn {
        background-color: #409eff;
        border-color: #409eff;
      }
    }
  }
  .goodsInfo {
    border-top: 1px solid #ddd;
  }
  .el-tabs__item.is-active {
    color: #ff4d4f !important;
  }
  .el-tabs__item:hover {
    color: #ff4d4f !important;
  }
}
.red-color-text {
  color: red;
  font-size: 20px;
  font-weight: bold;
  display: inline-block;
  padding: 0 5px;
}
.notice {
  color: #409eff;
  cursor: pointer;
}
.serch-wrap {
  position: relative;
  padding-right: 50px;
}
.drop-down-wrap {
  position: absolute;
  right: 20px;
  top: 5px;
}
.hint {
  width: 300px;
  margin: 0 auto;
  background: #f2f2f2;
  padding: 10px 0px 10px 15px;
  color: #000;
  font-weight: bold;
  margin-bottom: 20px;
  .title {
    margin-bottom: 15px;
  }
  .warning {
    margin-top: 15px;
    color: #949494;
    font-weight: 500;
    font-size: 12px;
    span {
      color: #000;
      font-weight: bold;
    }
  }
  .content span {
    color: #409eff;
  }
  .red-alert span {
    color: red;
  }
}
.ask {
  text-align: center;
  span {
    color: #409eff;
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/order/order.vue